module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-1-p-bb95417fd86eeab5b870f7c1e0d6e88b.gif";